import { render } from "./driver-tips.vue?vue&type=template&id=46631aba&scoped=true"
import script from "./driver-tips.vue?vue&type=script&lang=js"
export * from "./driver-tips.vue?vue&type=script&lang=js"

import "./driver-tips.vue?vue&type=style&index=0&id=46631aba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46631aba"]])

export default __exports__